import LocationSubscriber from './LocationSubscriberContainer';

export default LocationSubscriber;
